export default __webpack_public_path__ + "static/media/zingPcv1.9986b7fe.png";